<p-inputgroup>
  <input [placeholder]="( 'app.fields.search' | translate ) + '...'" pInputText/>
  <p-inputgroup-addon>
    <p-button icon="pi pi-search" severity="secondary" variant="text"/>
  </p-inputgroup-addon>
</p-inputgroup>
